<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">wh10介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="intent">
                星格证研价值投资软件wh10，是文华财经专为股票投资机构精心打造的证券研究软件，wh10聚焦股票的价值分析和量化研究。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        
        
        <div class="details_gn" v-show="num == 1">
            <!-- <p class="detail_title">B套餐</p>
            <br>
            <br> -->
            
            <p class="tent">1.包含套餐B功能</p>
            <p class="tent">2.提供了包括设定选股范围、选择因子、检验因子有效性、因子时效性参考、分析因子相关性、合成综合因子、生成持仓股票池、净值优化、择时优化、策略分析报告、调仓建议等功能的全流程多因子量化工具。</p>
            <!-- <p class="tent">* 仅限使用wh10软件登录</p> -->
            <p class="tent">* 本服务中必须提供的数据及信息仅限用户另外付费选配的范围；服务期内我司有权对其他数据及信息进行增、减等调整。</p>
            <a target="_blank" href="https://wt10.wenhua.com.cn/index.html?aspxerrorpath=/#/buy">>>> 查看wh10套餐C更多功能</a>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.付费成功后如无功能问题恕不退不换。</p>
            <p class="tent">2.购买前请先下载<a href="https://wt10.wenhua.com.cn/index.html?aspxerrorpath=/#/home" target="_blank">wh10</a>体验版了解软件基础功能。</p>
            <p class="tent" style='padding-left:12px;text-indent:-12px;'>
                3.使用wh10的电脑配置要求：<br />
                · X86架构的CPU，4核及以上配置；<br />
                · win7/win2008的64位操作系统，4G内存；<br />
                · win10/win8的64位操作系统，8G内存；
            </p>
            <p class="tent">4.推荐南方地区使用电信网络，北方地区使用联通网络，其它网络使用效果不佳。</p>
            
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn{
    min-height: 255px;
}
.details_gn p.tent {
    
}
</style>